import md5 from '../../../static/utils/md5';
/**
 * 数字格式化
 *
 * @param {number} num 数字
 * @param {boolean} showK 是否显示K
 * @param {boolean} isMinimum 是否有兜底人数显示
 * @return {string} 格式化后的字符串
 */
/* globals getApp swan */
export const formatNumEn = (num, showK = true, isMinimum = false) => {
  // 暂时去掉大于一千万的展示逻辑
  // if (num >= Math.pow(10, 7)) {
  //     return (num / Math.pow(10, 6)).toFixed(1) + 'Mn';
  // }
  // else
  if (num >= 10000) {
    return (num / 10000).toFixed(1) + 'w';
  } else if (num >= 1000 && showK) {
    return (num / 1000).toFixed(1) + 'k';
  } else if (num < 10 && isMinimum) {
    return 10;
  }
  return num;
};

/**
 * 问一问回插回答预处理
 *
 * @param {Object} singleReply 单条回答对象
 * @param {String} pageType 页面类型
 */

export function processReplyEntry(singleReply, pageType) {
  if (singleReply) {
    // 当前回答的回答entry
    let replyEntry = singleReply.ext_pack && singleReply.ext_pack.reply_entry;
    // 当前回答的导入id, 1601-推搜索、1602-新建付费围观、1603-回插付费围观、1608-新建大V付费围观、1609-回插大V付费围观
    let importId = +singleReply.import_id;
    // 新版回插对话样式：有payChatList，则代表为付费围观回答（包括普通的付费围观、大V的付费围观；从位置分析，可分为非首答、首答）、或为推搜索。
    let isNewChatStyle = singleReply.payChatList && singleReply.payChatList.length > 0;
    // 非首位的付费围观回答：有aid且isPayChat为1，展示成付费的样式。
    let isNotFirstCircusee = singleReply.aid && singleReply.isPayChat === 1;
    // 普通的付费围观回答：1602-新建的付费围观，1603-回插的付费围观。
    let isNormalPayBrowse = [1602, 1603].includes(importId);
    // 大V的付费围观回答：1608-新建的大V付费围观，1609-回插的大V付费围观。 iknownew-16971 pm-zhengqi01
    let isBiggiePayBrowse = [1608, 1609].includes(importId);
    // 带有推搜索标识的回答：importId为1601、且import_source不为1.
    let isPushWise = importId === 1601 && singleReply.ext_pack && 1 !== +singleReply.ext_pack.import_source;

    /**
     * singleReplyType - 回答的样式特征及类型
     * 1. 免费的回插回答
     *      1.0 是免费的回插回答, 等价于 hasWywHeader && !isNewChatStyle && replyStyle === 'chat'
     *      1.1 singleReplyType取其replyEntry值，即 singleReplyType=newans_insert
     * 2. 付费围观的回答
     *      2.0 是付费围观(isPayBrowse为true), 等价于 hasWywHeader && isNewChatStyle && isShowAbstract
     *      2.1 包含普通的付费围观回答(singleReplyType=pay_browse)、大V的付费围观回答(singleReplyType=biggie_pay_browse)
     *          2.1.1 普通的付费围观回答(pay_browse)
     *                  2.1.1.1 首位的普通付费围观回答: isPayBrowse && isNormalPayBrowse && !isNotFirstCircusee
     *                  2.1.1.2 非首位的普通付费围观回答: isPayBrowse && isNormalPayBrowse && isNotFirstCircusee
     *          2.1.2 大V的付费围观回答(biggie_pay_browse)
     *                  2.1.2.1 首位的大V付费围观回答: isPayBrowse && isBiggiePayBrowse && !isNotFirstCircusee
     *                  2.1.2.2 非首位的大V付费围观回答: isPayBrowse && isBiggiePayBrowse && isNotFirstCircusee
     * 3. 推搜索的回答
     *      3.0 是推搜索的回答, 等价于 hasWywHeader && isNewChatStyle && isShowAbstract && isPushWise
     *      3.1 singleReplyType=push_wise
     */

    let singleReplyType = replyEntry;
    if (isNewChatStyle) {
      isPushWise && (singleReplyType = 'push_wise');
      isNormalPayBrowse && (singleReplyType = 'pay_browse');
      isBiggiePayBrowse && (singleReplyType = 'biggie_pay_browse');
    }
    Object.assign(singleReply, {
      // 回答类型
      singleReplyType,
      // 回答头部：是否改为问一问。
      hasWywHeader: singleReply.ext_pack && singleReply.ext_pack.isShowWywHeader,
      // 是否为新版回插对话样式：即是否用chatconsult组件、且有payChatList
      isNewChatStyle,
      // 内容样式：是对话样式(用chatconsult组件)、还是普通回答样式。
      replyStyle: replyEntry === 'newans_insert' || isNewChatStyle ? 'chat' : 'reply',
      // 是否展示摘要内容：如果对话内容只有1条回答(首条固定为问一问的提问标题)，则不展示摘要
      isShowAbstract: singleReply.payChatList && singleReply.payChatList.length > 2 && singleReply.abstractContentList && singleReply.abstractContentList.length > 0,
      // 非首位的付费围观回答
      isNotFirstCircusee,
      // 多QB页的非首位的付费围观回答：展现付费围观条、内容区设有最大高度
      isQbNotFirstCircusee: pageType === 'question' && isNotFirstCircusee,
      // 普通的付费围观回答
      isNormalPayBrowse: +isNormalPayBrowse,
      // 大V的付费围观回答
      isBiggiePayBrowse: +isBiggiePayBrowse,
      // 推搜索回答
      isPushWise
    });
  }
}
export const getCurrentUrlfrFunc = flag => {
  let newQuery;
  {
    const url = window.location.href;
    let search = url.substring(url.lastIndexOf('?') + 1);
    let obj = {};
    search.replace(/([^?&=#]+)=([^?&#]*)/g, function (rs, $1, $2) {
      obj[$1] = $2 || '';
      return rs;
    });
    newQuery = obj;
  }
  const {
    fr
  } = newQuery;
  // flag为true是想获取fr，存在并且等于dqa直接返回
  if (flag && fr === 'dqa') {
    return fr;
  }
  // flag为false是想获取query字符串，存在并且等于dqa拼接完直接返回
  else if (fr === 'dqa') {
    return `&fr=${fr}`;
  }
  // 不满足条件直接返回空串
  return '';
};
export const setNumThousands = function (num) {
  let numb = (num || 0).toString();
  let result = '';
  while (numb.length > 3) {
    result = ',' + numb.slice(-3) + result;
    numb = numb.slice(0, numb.length - 3);
  }
  if (numb) {
    result = numb + result;
  }
  return result;
};
export const foldTextOnly = function (text, num) {
  text = text.replace(/\n/g, '');
  if (text.length > num) {
    text = text.substr(0, num) + '...';
  }
  return {
    text,
    hasMoreReplyInfo: text.length > num
  };
};

/**
 * 格式化数字: 小于10数字加零值
 * @param {String} n 原数字
 * @returns 处理完成的String格式数字
 */

export const formatNumber = n => {
  n = n.toString();
  return n[1] ? n : '0' + n;
};

/**
 * 后端秒级时间转换日期字符串
 * @param {String} dateStr date对象
 * @returns 处理完成的String日期
 */

export const formatTimeToDate = dateStr => {
  let date = new Date(parseInt(dateStr, 10) * 1000);
  const year = date.getFullYear();
  const month = date.getMonth() + 1;
  const day = date.getDate();
  return [year, month, day].map(formatNumber).join('-');
};

/**
 * 毫秒级时间转换日期字符串
 * @param {String} dateStr date对象
 * @returns 处理完成的String日期
 */

export const formatTimesToDate = dateStr => {
  let date = new Date(dateStr);
  const year = date.getFullYear();
  const month = date.getMonth() + 1;
  const day = date.getDate();
  const h = date.getHours();
  const m = date.getMinutes();
  const s = date.getSeconds();
  return [year, month, day].map(formatNumber).join('-') + ' ' + [h, m, s].map(formatNumber).join(':');
};

/**
 * 关键词飘红
 * @param {String} content 内容字符串
 * @param {Array} topic 关键词数组
 */

export const handleKeyWord = (content = '', topic = []) => {
  let start = 0;
  let richTitle = '';
  topic && topic.forEach((topicItem, topicIndex) => {
    let titleArr = content.split('') || [];
    richTitle += titleArr.slice(start, topicItem.start_offset).join('') + `<span style="color:#d81419">${titleArr.slice(topicItem.start_offset, topicItem.end_offset + 1).join('')}</span>`;
    // 到结尾了
    if (topicIndex === topic.length - 1) {
      richTitle += titleArr.slice(topicItem.end_offset + 1, titleArr.length).join('');
    } else {
      start = topic[topicIndex + 1][1];
      richTitle += titleArr.slice(topicItem.end_offset + 1, start).join('');
    }
  });
  // 替换掉\r\n
  let regObj = new RegExp('(\r)|(\n)', 'g');
  richTitle = richTitle && richTitle.replace(regObj, '');
  return richTitle || content;
};

/**
 * 格式化法典、法规词高亮,换行问题需单独处理
 * 通过type来判断高亮词，法规飘蓝部分有type字段，法典飘蓝部分有的没有type，则使用自定义type字段
 * 其中type的值，法典是law_struct，法规是law_regulation，自定义字段为highlight
 * @param {String} content 内容字符串
 * @param {Array} highlight 高亮法典词数组
 */

export const handleHighLightContent = (content, highlight) => {
  let textArr = []; // 初始化文本数组
  highlight && highlight.map((highItem, index) => {
    // 遍历高亮数据
    if (highItem.begin_index !== 0) {
      // 如果关键词起始位置不为0
      textArr.push({
        text: '<span>' + content.substring(index === 0 // 判断是不是第一项关键词，如果是，则从0开始，不是则从前一项关键词的结束位置开始
        ? 0 : highlight[index - 1].end_index, highItem.begin_index) + '</span>'
      });
    }
    textArr.push({
      // 关键词高亮处理
      text: content.substring(highItem.begin_index, highItem.end_index),
      type: 'highlight',
      ...highItem
    });
    if (index === highlight.length - 1 && highlight[index].end_index !== content.length) {
      // 最后一个关键词，判断关键词后面是否还有文字
      textArr.push({
        text: '<span>' + content.substring(highlight[index].end_index, content.length) + '</span>'
      });
    }
    return highItem;
  });
  return textArr;
};

/**
 * 法规词高亮处理
 * h5当contenRich为空时，使用contentList渲染页面
 * 小程序页面，全部使用contentList渲染页面
 * @param {Array} highlight 高亮法典词数组 与value同级
 */

export const handleHighLightValue = content => {
  if (!Array.isArray(content)) {
    return [];
  }
  return content.map(item => {
    const {
      value
    } = item;
    // 如果是数组，则遍历数组 只有有highlight字段才做处理
    if (item instanceof Array) {
      return item.map(v => {
        const {
          value
        } = v;
        if (v.highlight) {
          return {
            ...v,
            value: handleHighLightContent(v.value, v.highlight)
          };
        }
        return {
          ...v,
          value: [{
            text: value
          }]
        };
      });
    }
    if (item.highlight) {
      return {
        ...item,
        value: handleHighLightContent(item.value, item.highlight)
      };
    }
    return {
      ...item,
      value: [{
        text: value
      }]
    };
  });
};

/**
 * 相关推荐列表处理
 * @param {Array} list 相关推荐列表
 * @param {Number} adLength 广告长度
 * @param {Number} adType 广告类型
 * @param {Number} otherAdLength 其他类型广告长度
 * @param {Number} otherAdType 其他类型广告类型
 */
export const handleRecommendList = (list = [], adLength, adType, otherAdLength = 0, otherAdType) => {
  const result = [];
  const ad_length = otherAdLength ? otherAdLength + adLength : adLength;
  const maxLength = Math.max(list.length, ad_length);
  for (let i = 0; i < maxLength; i++) {
    list[i] && result.push(list[i]);
    if (otherAdLength && otherAdLength > i) {
      result.push({
        type: otherAdType,
        module: true,
        isAd: true,
        order: i
      });
    } else {
      adLength > i - otherAdLength && result.push({
        type: adType,
        module: true,
        isAd: true,
        order: i - otherAdLength
      });
    }
  }
  return result;
};